<template>
  <v-dialog
    v-model="tripOrdersListDialog"
    persistent
    scrollable
    max-width="90%"
    transition="dialog-bottom-transition"
    @keydown.esc="closeDialog()"
  >
    <v-card>
      <v-card-title class="heading">
        <span
          class="text-lg-subtitle-1 text-xl-h6 text-uppercase font-weight-black text_color--text"
        >
          {{ tripModule.trip }}'s {{ orderModule.orderPlural }} list
        </span>
        <v-spacer />
        <v-btn
          id="trip'sOrderListClose"
          depressed
          text
          small
          icon
          class="primary-text mt-n2"
          @click="closeDialog()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div v-if="showDetails">
          <v-row class="ma-0">
            <v-col class="d-flex justify-space-between align-center">
              <v-btn
                depressed
                class="secondary"
                icon
                @click="showDetails = false"
              >
                <v-icon color="white">mdi-arrow-left</v-icon>
              </v-btn>
              <v-slide-group
                v-model="selectedOrder"
                center-active
                show-arrows
                next-icon="mdi-arrow-right-drop-circle"
                prev-icon="mdi-arrow-left-drop-circle"
              >
                <v-slide-item
                  v-for="order in currentTrip.orders"
                  :value="order"
                  :key="order.reference_number"
                  v-slot="{ active, toggle }"
                >
                  <v-btn
                    v-if="order && !order.is_duplicate"
                    class="mx-2"
                    :input-value="active"
                    :color="active ? 'primary' : 'subHeading lighten-1'"
                    depressed
                    rounded
                    @click="toggle"
                  >
                    {{ order.reference_number }}
                  </v-btn>
                </v-slide-item>
              </v-slide-group>
            </v-col>
            <v-col
              cols="12"
              class="background_color overflow-y-auto"
              style="max-height: 65vh"
            >
              <OrderDetails
                ref="orderDetails"
                :id="selectedOrder.id"
                :type="selectedOrderSegment"
                @action="tripOrdersListDialog = false"
              />
            </v-col>
          </v-row>
        </div>
        <v-row class="pb-6" v-if="!showDetails">
          <v-col cols="9"> </v-col>
          <v-col cols="3" class="mt-7 mb-3 d-flex align-center">
            <InputField
              outlined
              hide-details
              dense
              clearable
              prepend-inner-icon="mdi-magnify"
              label="search orders here"
              v-model="search"
              @input="getOrderListSearching()"
            ></InputField>
          </v-col>
          <AgGridVue
            class="ag-theme-balham"
            @grid-ready="gridReady"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :defaultColDef="defaultColDef"
            :row-data="currentTrip.orders"
            :tooltipShowDelay="0"
            :context="context"
            style="width: 100%; height: 65vh"
          >
          </AgGridVue>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { tripModule, orderModule } from "@/utils/moduleMapping";
import { AgGridVue } from "ag-grid-vue";
import TripOrderButton from "@/components/Button/TripOrderButton.vue";
import OrderDetails from "@/components/ModuleBasedComponents/Order/OrderDetails.vue";
export default {
  props: {
    value: Boolean,
    currentTrip: Object,
  },
  components: {
    AgGridVue,
    TripOrderButton,
    OrderDetails,
  },
  data() {
    return {
      tripModule,
      orderModule,
      search: "",
      gridApi: null,
      columnApi: null,
      gridOptions: {
        onGridSizeChanged: () => {
          this.gridOptions.api.sizeColumnsToFit();
          // setTimeout(() => {
          //   this.autoSizeAll();
          // }, 200);
        },
        headerHeight: 40,
        rowHeight: 34,
        tooltipShowDelay: 0,
        suppressRowClickSelection: true,
        suppressDragLeaveHidesColumns: true,
        enableCellTextSelection: true,
      },
      defaultColDef: {
        lockPosition: true,
        // flex: 1,
        resizable: true,
        sortable: true,
        autoHeight: true,
        cellStyle: {
          "text-overflow": "ellipsis",
          "white-space": "nowrap",
          overflow: "hidden",
          display: "block",
        },
      },
      selectedOrder: {},
      selectedOrderSegment: null,

      showDetails: false,
    };
  },
  watch: {
    value(val) {
      if (val) {
        setTimeout(() => {
          this.autoSizeAll();
        }, 100);
      } else {
        this.showDetails = false;
      }
    },
  },
  computed: {
    context() {
      return { parentComponent: this };
    },
    columnDefs() {
      let column = [
        {
          headerName: "reference number",
          headerTooltip: "Reference Number",
          field: "reference_number",
          pinned: "left",
          minWidth: 200,
        },
        {
          headerName: "Order Segment",
          headerTooltip: "Order Segment",
          field: "order_segment",
        },
        // {
        //   headerName: "Order Type",
        //   headerTooltip: "Order Type",
        //   field: "order_type",
        // },
        {
          headerName: "address",
          headerTooltip: "Address",
          field: "address",
        },
        // {
        //   headerName:"unit name",
        //   field: "unit_name",
        // },
        {
          headerName: "customer name",
          field: "customer_name",
        },
        {
          headerName: "contact number",
          field: "contact_number",
        },
        // {
        //   headerName:"invoice number",
        //   field: "invoice_number",
        // },
        {
          headerName: "order status",
          field: "verbose_status",
          cellClass: "text-capitalize",
        },
        // {
        //   headerName:"dry",
        //   field: "total_dry_items",
        // },
        // {
        //   headerName:"chiller",
        //   field: "total_chilled_items",
        // },
        // {
        //   headerName:"frozen",
        //   field: "total_frozen_items",
        // },
        // {
        //   headerName:"technical",
        //   field: "total_technical_items",
        // },
        // {
        //   headerName:"Sales quantity",
        //   field: "original_quantity",
        // },
      ];

      if (this.currentTrip.tripStatus == "scheduled") {
        // column.push({
        //   headerName:"planned processing time",
        //   headerTooltip: "Planned Processing Time",
        //   field: "planned_processing_time",
        // });
      } else if (this.currentTrip.tripStatus == "completed") {
        column.push(
          {
            headerName: "delivered quantity",
            headerTooltip: "Delivered Quantity",
            field: "delivered_quantity",
          },
          {
            headerName: "planned processing time",
            headerTooltip: "Planned Processing Time",
            field: "planned_processing_time",
          },
          {
            headerName: "actual processing time",
            headerTooltip: "Actual processing time",
            field: "actual_processing_time",
            cellRenderer: (params) => {
              return params.value != null ? params.value : "-";
            },
          }
        );
      } else {
        column.push(
          {
            headerName: "planned processing time",
            headerTooltip: "Planned Processing Time",
            field: "planned_processing_time",
          },
          {
            headerName: "actual processing time",
            headerTooltip: "Actual processing time",
            field: "actual_processing_time",
            cellRenderer: (params) => {
              return params.value != null ? params.value : "-";
            },
          }
        );
      }
      column.push({
        headerName: "Action",
        field: "action",
        pinned: "right",
        cellRenderer: "TripOrderButton",
      });
      return column;
    },
    tripOrdersListDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    getOrderDetails(order) {
      this.selectedOrder = order;
      this.selectedOrderSegment = order.order_segment;
      this.showDetails = true;
    },
    getOrderListSearching() {
      this.gridOptions.api.setQuickFilter(this.search);
    },
    autoSizeAll() {
      let allColumnIds = [];
      this.gridOptions.columnApi.getColumns().forEach(function (column) {
        allColumnIds.push(column.colId);
      });
      this.gridOptions.columnApi.autoSizeColumns(allColumnIds);
    },
    gridReady(params) {
      this.gridApi = params.api;
      this.columnApi = params.columnApi;
    },
    closeDialog() {
      this.tripOrdersListDialog = false;
    },
  },
};
</script>